import { styled } from '@mui/material';

export const SidebarDivider = styled('hr')(({ theme }) => ({
  height: 1,
  width: '100%',
  background: theme.palette.divider,
  border: 'none',
  margin: theme.spacing(1.2, 0),
}));
